<template>
  <div>
    <v-alert
      colored-border
      dense
      outlined
      :data-tourid="
        `${entity}-${isCanceledStatus ? 'canceled' : 'onHold'}-alert`
      "
      border="left"
      class="alert-container text-caption pa-4"
      :color="isCanceledStatus ? 'blue-grey darken-2' : 'yellow'"
      :icon="isCanceledStatus ? 'mdi-cancel' : 'mdi-pause-circle-outline'"
    >
      <v-row align="center">
        <v-col class="grow">
          <span v-html="$sanitize(changedBy, { allowedTags: ['b'] })" />
        </v-col>
        <v-col class="shrink">
          <Button
            size="small"
            class="white--text"
            data-testid="ChangedRevStateAlert-button-view"
            :data-tourid="
              `${entity}-${
                isCanceledStatus ? 'canceled' : 'onHold'
              }-alertButton`
            "
            :color="isCanceledStatus ? 'blueGreyDarken' : 'warning'"
            :text="$t('common.button.view_more')"
            @click="openModal"
          />
        </v-col>
      </v-row>
    </v-alert>
    <ChangedStateDetailModal
      :data-testid="
        `ChangedRevStateAlert-ChangedStateDetailModal-${entity}Modal`
      "
      :data-tourid="
        `${entity}-${isCanceledStatus ? 'canceled' : 'onHold'}-reasonModal`
      "
      :data="data"
      :open="showModal"
      :entity="entity"
      @close="showModal = false"
    />
  </div>
</template>

<script>
import Button from '@/components/UI/Button'
import ChangedStateDetailModal from '@/containers/Modals/ChangedStateDetailModal.vue'
import userMixin from '@/mixins/userMixin.vue'
import trackerMixin from '@/mixins/tracking/trackerMixin.vue'

const ENTITIES = { rev: 'Rev', finding: 'Finding' }
export default {
  name: 'ChangedStatusAlert',
  components: {
    Button,
    ChangedStateDetailModal,
  },
  props: {
    data: {
      type: Object,
    },
    entity: {
      type: String,
      required: false,
      default: ENTITIES.rev,
    },
  },
  mixins: [userMixin, trackerMixin],
  data() {
    return {
      showModal: false,
      ENTITIES,
    }
  },
  computed: {
    canceledStatus() {
      if (this.entity == this.ENTITIES.rev)
        return this.$constants.revStatus.canceled
      return this.$constants.findings.status.canceled
    },

    isCanceledStatus() {
      return Boolean(this.data?.status === this.canceledStatus)
    },

    changedBy() {
      if (this.data?.status === this.canceledStatus)
        return this.$t('common.has_canceled', {
          user: this.getFullName(this.data.canceledBy) ?? {},
          entity: this.entity,
        })
      return this.$t('common.put_on_hold', {
        user: this.getFullName(this.data.onHoldBy) ?? {},
        entity: this.entity,
      })
    },
  },

  methods: {
    openModal() {
      this.showModal = true
      if (this.entity === this.ENTITIES.rev)
        return this.trackRevReason(this.data?.status)
      this.trackFindingReason(this.data?.status)
    },
  },
}
</script>
<style lang="scss" scoped>
.alert-container {
  background-color: $color-white !important;
}
</style>
